/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DoCheck, Inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import template from './order-analysis-page.component.html';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

type OrderAnalysisTab = 'charts' | 'stats' | 'tags' | 'reports' | 'traffic' | 'location';

@Component({
  standalone: false,
  selector: 'adn-order-analysis-page',
  template
})
export class OrderAnalysisPageComponent implements OnChanges, DoCheck {
  @Input() model: any;
  private _modelCommsDirect: any;
  private _isNewDirect: boolean | undefined;
  private _chartCurrencyDirect: any;

  @Input()
  set modelComms(value: any) {
    this._modelCommsDirect = value;
  }

  get modelComms(): any {
    return this._modelCommsDirect;
  }

  @Input()
  set isNew(value: boolean) {
    this._isNewDirect = value;
  }

  get isNew(): boolean {
    return this._isNewDirect;
  }

  @Input()
  set chartCurrency(value: any) {
    this._chartCurrencyDirect = value;
  }

  get chartCurrency(): any {
    return this._chartCurrencyDirect;
  }

  effectiveIsNew = false;
  tagModel: {model: any} = {model: null};
  activeTab: OrderAnalysisTab = 'charts';
  statsLoaded = false;
  tagsLoaded = false;
  reportsLoaded = false;
  trafficLoaded = false;
  locationLoaded = false;
  canSeeReports = false;

  private lastModelId: string | undefined;
  private subscribedModelComms: any;

  constructor(@Inject(LocalUserPermissions) private readonly LocalUserPermissions: any) {
    const perms = LocalUserPermissions.getAllVisPermissions();
    this.canSeeReports = LocalUserPermissions.getAnyVisibility().RUN_REPORTS === true || perms.AX_ADVERTISER;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.model) {
      this.tagModel = {model: this.model};
    }
    if (changes.modelComms) {
      this.subscribeModelComms();
    }
  }

  ngDoCheck(): void {
    const modelId = this.model?.id;
    if (modelId !== this.lastModelId) {
      this.lastModelId = modelId;
      this.tagModel = {model: this.model};
    }
  }

  selectTab(tab: OrderAnalysisTab): void {
    this.activeTab = tab;
    if (tab === 'stats') {
      this.statsLoaded = true;
    } else if (tab === 'tags') {
      this.tagsLoaded = true;
    } else if (tab === 'reports') {
      this.reportsLoaded = true;
    } else if (tab === 'traffic') {
      this.trafficLoaded = true;
    } else if (tab === 'location') {
      this.locationLoaded = true;
    }
  }

  private subscribeModelComms(): void {
    if (!this.modelComms || this.subscribedModelComms === this.modelComms) {
      return;
    }
    this.subscribedModelComms = this.modelComms;
    // Route isNew never flips after save; modelComms does.
    this.modelComms.addSubscriber((data: any, type: any, isNewFromComms?: boolean) => {
      if (type) {
        return;
      }
      if (isNewFromComms === true || isNewFromComms === false) {
        this.effectiveIsNew = isNewFromComms;
      } else if (data?.name) {
        this.effectiveIsNew = false;
      }
    });
  }
}
